import { render, staticRenderFns } from "./UpdateTeacherView.vue?vue&type=template&id=57faa112&scoped=true&"
import script from "./UpdateTeacherView.vue?vue&type=script&lang=js&"
export * from "./UpdateTeacherView.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTeacherView.vue?vue&type=style&index=0&id=57faa112&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57faa112",
  null
  
)

export default component.exports